import { createSelector } from "@reduxjs/toolkit";

import { findById, getValidationsMessages } from "../components/others";
import { processCategories } from "../components/processContent/processContent";

// Required States

// createQstnPaper

const formData = (store) => store.createQstnPaper.formData;
const subjects = (store) => store.createQstnPaper.subjects;
const classes = (store) => store.createQstnPaper.classes;
const isSubmitted = (store) => store.createQstnPaper.isSubmitted;

// createPaperEditor

const categories = (store) => store.createPaperEditor.categories;
const questions = (store) => store.createPaperEditor.questions;

// getNameById

export const getNameById = createSelector(
  [formData, subjects, classes],
  (formData, subjects, classes) => {
    return findById(formData, subjects, classes);
  }
);

// getContent

export const getContent = createSelector(
  [categories, questions, formData, getNameById],
  (categories, questions, formData, nameById) => {
    const { subjectName, className } = nameById;
    return processCategories(questions, categories, {
      ...formData,
      subjectName,
      className,
    });
  }
);

// getValidationMessages

export const getValidationMessages = createSelector(
  [categories, questions, formData, isSubmitted],
  (categories, questions, formData, isSubmitted) => {
    let message = `Validation Warnings: `;
    let displayMessage = false;
    const maxMarks = Number(formData.maxMarks);

    const validations = getValidationsMessages(
      categories,
      questions,
      maxMarks,
      isSubmitted
    );

    message += validations.message;
    displayMessage = validations.displayMessage;

    return { message, displayMessage };
  }
);
